<!-- eslint-disable prettier/prettier -->
<template>
	<svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :fill="color" class="ki ki-minus-parens" viewBox="0 0 24 24">
	<path d="M6,18.7c-1.8-1.6-3-4.1-3-6.7c0-2.7,1.2-5.1,3-6.7V4c-2.4,1.8-4,4.7-4,8 c0,3.3,1.6,6.2,4,8V18.7z M18,18.7c1.8-1.6,3-4.1,3-6.7c0-2.7-1.2-5.1-3-6.7V4c2.4,1.8,4,4.7,4,8c0,3.3-1.6,6.2-4,8V18.7z M6,12.5 h12v-1H6V12.5z"/>
</svg>

</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		width?: number;
		height?: number;
		color?: string;
	}>(),
	{
		width: 24,
		height: 24,
		color: 'currentColor'
	}
);
</script>
